import { DATA_AUDIT_ACTIONS } from 'config';

/*STATIC CHART DATA ACTIONS*/
export function requestSaticChartData() {
  return {
    type: DATA_AUDIT_ACTIONS.REQUEST_STATIC_CHART_DATA
  };
}
export function setStaticChartData(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.SET_STATIC_CHART_DATA,
    payload
  };
}
export function setStaticChartError(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.SET_STATIC_CHART_DATA_ERROR,
    payload
  };
}

/*DATA AUDIT TYPE ACTION*/
export function setDataAuditDataType(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.SET_DATA_AUDIT_TYPE,
    payload
  };
}

/*STATIC BCBV DATA ACTIONS*/
export function requestSaticBCBVData() {
  return {
    type: DATA_AUDIT_ACTIONS.REQUEST_STATIC_BCBV_DATA
  };
}
export function setSaticBCBVData(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.SET_STATIC_BCBV_DATA,
    payload
  };
}
export function setSaticBCBVDataError(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.SET_STATIC_BCBV_DATA_ERROR,
    payload
  };
}

/*NPI DISTRIBUTION ACROSS COUNTRY ACTIONS*/
export function requestNpiDistributionAcrossCountry(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.REQUEST_NPI_DISTRIBUTION_ACROSS_COUNTRY,
    payload
  };
}
export function setNpiDistributionAcrossCountry(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.SET_NPI_DISTRIBUTION_ACROSS_COUNTRY,
    payload
  };
}
export function setNpiDistributionAcrossCountryError(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.SET_NPI_DISTRIBUTION_ACROSS_COUNTRY_ERROR,
    payload
  };
}

/*DRG BY HOSPITAL WITH NTYPE ACTIONS*/
export function requestDrgByHospitalCountWithNtype(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.REQUEST_DRG_BY_HOSPITAL_COUNT_WITH_N_TYPE,
    payload
  };
}
export function setDrgByHospitalCountWithNtype(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.SET_DRG_BY_HOSPITAL_COUNT_WITH_N_TYPE,
    payload
  };
}
export function setDrgByHospitalCountWithNtypeError(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.SET_DRG_BY_HOSPITAL_COUNT_WITH_N_TYPE_ERROR,
    payload
  };
}

/*HOSPITAL COUNT DRG ACTIONS*/
export function requestHospitalCountDrg(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.REQUEST_HOSPITAL_COUNT_DRG,
    payload
  };
}
export function setHospitalCountDrg(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.SET_HOSPITAL_COUNT_DRG,
    payload
  };
}
export function setHospitalCountDrgError(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.SET_HOSPITAL_COUNT_DRG_ERROR,
    payload
  };
}

/*DISTING DRG BY NEGOTIATIONS ACTIONS*/
export function requestDistingDrgByNegotiations(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.REQUEST_DISTING_DRG_BY_NEGOTIATIONS,
    payload
  };
}
export function setDistingDrgByNegotiations(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.SET_DISTING_DRG_BY_NEGOTIATIONS,
    payload
  };
}
export function setDistingDrgByNegotiationsError(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.SET_DISTING_DRG_BY_NEGOTIATIONS_ERROR,
    payload
  };
}

/*PROVIDER DRG BY HOSPITAL ACTIONS*/
export function requestProviderDrgByHospital(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.REQUEST_PROVIDER_DRG_BY_HOSPITAL,
    payload
  };
}
export function setProviderDrgByHospital(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.SET_PROVIDER_DRG_BY_HOSPITAL,
    payload
  };
}
export function setProviderDrgByHospitalError(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.SET_PROVIDER_DRG_BY_HOSPITAL_ERROR,
    payload
  };
}

/*STATE DRG BY HOSPITAL ACTIONS*/
export function requestStateDrgByHospital(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.REQUEST_STATE_DRG_BY_HOSPITAL,
    payload
  };
}
export function setStateDrgByHospital(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.SET_STATE_DRG_BY_HOSPITAL,
    payload
  };
}
export function setStateDrgByHospitalError(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.SET_STATE_DRG_BY_HOSPITAL_ERROR,
    payload
  };
}

/*HOSPITAL COUNT BY DRG ACTION*/
export function setHospitalCountByDRG(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.REQUEST_HOSPITAL_COUNT_BY_DRG,
    payload
  };
}

/*PCH CODE TYPE ACTIONS*/
export function requestPCHCodeType(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.REQUEST_PCH_CODE_TYPE,
    payload
  };
}
export function setPCHCodeType(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.SET_REQUEST_PCH_CODE_TYPE,
    payload
  };
}
export function setPCHCodeTypeError(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.SET_REQUEST_PCH_CODE_TYPE_ERROR,
    payload
  };
}

/*PCH NEGOTIATED TYPE ACTIONS*/
export function requestPCHNegotiatedType(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.REQUEST_PCH_NEGOTIATED_TYPE,
    payload
  };
}
export function setPCHNegotiatedType(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.SET_REQUEST_PCH_NEGOTIATED_TYPE,
    payload
  };
}
export function setPCHNegotiatedTypeError(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.SET_REQUEST_PCH_NEGOTIATED_TYPE_ERROR,
    payload
  };
}

/*PCH L1 DESCRIPTION ACTIONS*/
export function requestPCHL1Description(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.REQUEST_PCH_L1_DESCRIPTION,
    payload
  };
}
export function setPCHL1Description(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.SET_REQUEST_PCH_L1_DESCRIPTION,
    payload
  };
}
export function setPCHL1DescriptionError(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.SET_REQUEST_PCH_L1_DESCRIPTION_ERROR,
    payload
  };
}

/*PCH REPORTING ENTITY ACTIONS*/
export function requestPCHReportingEntity(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.REQUEST_PCH_REPORTING_ENTITY,
    payload
  };
}
export function setPCHReportingEntity(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.SET_PCH_REPORTING_ENTITY,
    payload
  };
}
export function setPCHReportingEntityError(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.SET_PCH_REPORTING_ENTITY_ERROR,
    payload
  };
}

/*PCH CITY ACTIONS*/
export function requestPCHCity(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.REQUEST_PCH_CITY,
    payload
  };
}
export function setPCHCity(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.SET_PCH_CITY,
    payload
  };
}
export function setPCHCityError(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.SET_PCH_CITY_ERROR,
    payload
  };
}

/*PCH BILLING CODE MODIFIER ACTIONS*/
export function requestPCHBillingCodeModifier(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.REQUEST_PCH_BILLING_CODE_MODIFIER,
    payload
  };
}
export function setPCHBillingCodeModifier(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.SET_REQUEST_PCH_BILLING_CODE_MODIFIER,
    payload
  };
}
export function setPCHBillingCodeModifierError(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.SET_REQUEST_PCH_BILLING_CODE_MODIFIER_ERROR,
    payload
  };
}

/*PROCEDURE COST BY HOSPITAL ACTIONS*/
export function requestProcedureCostByHospital(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.REQUEST_PROCEDURE_COST_BY_HOSPITAL,
    payload
  };
}
export function setProcedureCostByHospital(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.SET_PROCEDURE_COST_BY_HOSPITAL,
    payload
  };
}
export function setProcedureCostByHospitalError(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.SET_PROCEDURE_COST_BY_HOSPITAL_ERROR,
    payload
  };
}

/*RESET PCH LIST ACTIONS*/
export function resetPCHList() {
  return {
    type: DATA_AUDIT_ACTIONS.RESET_PCH_LIST
  };
}

/*RESET PCH FILTERS STATE ACTIONW*/
export function resetPchFiltersState(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.RESET_PCH_FILTERS_STATE,
    payload
  }
} 

/*DRG REFERENCE TABLE ACTIONS */
export function requestDrgReferenceTable(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.REQUEST_DRG_REFERENCE_TABLE,
    payload
  };
}
export function setDrgReferenceTable(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.SET_DRG_REFERENCE_TABLE,
    payload
  };
}
export function setDrgReferenceTableError(payload) {
  return {
    type: DATA_AUDIT_ACTIONS.SET_DRG_REFERENCE_TABLE_ERROR,
    payload
  };
}

/*RESET HOSPITAL COUNT WITH NTYPE ACTIONS*/
export function resetHospitalCountWithNType() {
  return {
    type: DATA_AUDIT_ACTIONS.RESET_HOSPITAL_COUNT_WITH_N_TYPE
  };
}
